// Use namespace import to work around CommonJS/ESM issues
import * as FormatterBase from "@hopper-i18n/formatter-base";

// Define noFractionOptions inline to avoid circular dependency through @hsbc/utilities
const noFractionOptions = {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
};

// Re-export everything from base - preserve both type and value
export {
  DateTimeFormatStyle,
  formatDateTime,
} from "@hopper-i18n/formatter-base";

// Custom formatCurrencyWithOptions with HSBC-specific defaults
export const formatCurrencyWithOptions = (params: {
  currencyCode: string;
  locale: string;
  amount: number;
  symbol?: string;
  options?: Intl.NumberFormatOptions;
}): string => {
  // Use noFractionOptions as default, but allow override through params.options
  const finalOptions = {
    ...noFractionOptions,
    ...params.options,
  };

  return FormatterBase.formatCurrencyWithOptions({
    ...params,
    options: finalOptions,
  });
};
